import { Shield, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-slate-950 text-white" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Logo & About */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-xl flex items-center justify-center">
                <Shield className="w-6 h-6 text-white" />
              </div>
              <div>
                <span className="font-heading text-2xl text-white tracking-tight">SHINGLE</span>
                <span className="font-heading text-2xl text-emerald-400 tracking-tight">CHECK</span>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed mb-6 max-w-md">
              The first website homeowners visit when they suspect roof damage. AI-powered satellite roof technology, 
              insurance estimate reviews, and professional roofing expertise for the DMV region.
            </p>
            <div className="flex gap-4">
              <a
                href="tel:+13013267333"
                className="flex items-center gap-2 text-slate-400 hover:text-emerald-400 transition-colors"
              >
                <Phone className="w-4 h-4" />
                (301) 326-7333
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg text-white mb-6">Quick Links</h4>
            <nav className="space-y-3">
              <button
                onClick={() => scrollToSection("view-roof")}
                className="block text-slate-400 hover:text-emerald-400 transition-colors"
              >
                View My Roof
              </button>
              <button
                onClick={() => scrollToSection("upload-estimate")}
                className="block text-slate-400 hover:text-emerald-400 transition-colors"
              >
                Estimate Review
              </button>
              <button
                onClick={() => scrollToSection("services")}
                className="block text-slate-400 hover:text-emerald-400 transition-colors"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection("storm-center")}
                className="block text-slate-400 hover:text-emerald-400 transition-colors"
              >
                Storm Center
              </button>
              <button
                onClick={() => scrollToSection("booking")}
                className="block text-slate-400 hover:text-emerald-400 transition-colors"
              >
                Schedule Inspection
              </button>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg text-white mb-6">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-emerald-400 mt-0.5" />
                <p className="text-slate-400">
                  6710 Oxon Hill Road
                  <br />
                  National Harbor, MD 20745
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-emerald-400" />
                <a
                  href="tel:+13013267333"
                  className="text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  (301) 326-7333
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-emerald-400" />
                <a
                  href="mailto:info@shinglecheck.com"
                  className="text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  info@shinglecheck.com
                </a>
              </div>
            </div>
            
            {/* Service Areas */}
            <div className="mt-6">
              <p className="text-slate-500 text-sm mb-2">Service Areas:</p>
              <div className="flex flex-wrap gap-2">
                <span className="text-xs text-slate-400 bg-slate-800 px-2 py-1 rounded">Washington DC</span>
                <span className="text-xs text-slate-400 bg-slate-800 px-2 py-1 rounded">Maryland</span>
                <span className="text-xs text-slate-400 bg-slate-800 px-2 py-1 rounded">Virginia</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} ShingleCheck. All rights reserved. Licensed in DC, MD & VA.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-slate-500 hover:text-emerald-400 text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-500 hover:text-emerald-400 text-sm transition-colors">
              Terms of Service
            </a>
            <a href="/admin" className="text-slate-500 hover:text-emerald-400 text-sm transition-colors">
              Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
